import React from 'react';

const ConfigPanelBody = ({ children, className }) => (
    <div className={`padding-default main-scroller ${className ?? ''}`}>{children}</div>
);

export default ConfigPanelBody;
